const connSettings = {
    host: `https://api.trevorlichfield.xyz:8443`
}

export default connSettings
